import { type DataLayerCallbackProps } from '@dhl/datalayer'
import { type DataLayerData, type DataLayerMeta } from '../types/types.js'
import { type AdobePageLoad } from './types.js'

export const writePageLoad = (dataLayerEvent: DataLayerCallbackProps<DataLayerData, DataLayerMeta>): void => {
  const {
    user: { status: userStatus, type: userType },
    app: { isNative, locale, nativeVersion, releaseVersion, tld },
  } = dataLayerEvent.data as DataLayerMeta

  const data: AdobePageLoad = {
    event: 'dhl_utf_pageload',
    page: {
      attributes: {
        is_native: isNative.toString(),
        native_version: nativeVersion,
        release_version: releaseVersion,
      },
      category: 'Tool',
      country: tld,
      finding_method: 'None',
      language: locale,
      name: dataLayerEvent.meta.url,
      publisher: 'EXP',
      section: `MDP ${tld}`,
      title: document.title,
    },
    user: {
      status: userStatus,
      type: userType,
    },
  }
  window.dataLayer?.push(data)
}
